<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <!-- Contenet page started-->
  <div class="row">
    <div class="col-md-12">
      <!-- breadcrumb -->
      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
          <li><a>Price Ticker Upload</a></li>
        </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home"><img src="../../../../assets/images/New_Icons/home-transprent-icon.svg"
                                     title="Home"></a>
        </div>
      </div>
    </div>
    <div class="block" style="margin-bottom: 0">
      <div class="screen_heading_div">
        <span>Price Ticker Upload</span>
      </div>
      <div class="row" style="padding-top: 30px">
        <div class="col-md-12">
          <div class="row">
            <div class="dropZoneContainer" [formGroup]="fileUploadForm">
              <input type="file" formControlName="fileUpload" id="drop_zone" class="FileUpload" accept=".xlsx"
                     title=" "
                     (change)="handleFileInput($event.target.files)"/>
              <div class="dropZoneOverlay">
                <button class="uploadImage"><img src="../../../../assets/img/Upload.svg"/></button>
                <br/>
                Drag & Drop OR Click to Upload<br/>
                .xlsx &nbsp; (max 20Mb)
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="filesContainer" *ngIf="fileUploadFlag">
  <div *ngIf="!uploadFileLoader">
    <div class="adjust loader-container">
      <div class="loader2"></div>
    </div>
  </div>
  <div class="rowStack" *ngIf="uploadFileLoader && closeFlag" style="border-bottom: none;display: flex;">
    <div style="width: 5%;float: left; padding-left: 247px; padding-right: 34px;">
      <button class="excelIcon"><img src="../../../../assets/img/Excel.svg"/></button>
    </div>
    <div style="display: grid;padding-left: 46px;padding-right: 20px;float: left;">
      <span style="font-size: 19px;">{{ fileName }}</span>
      <span style="font-size: 19px;text-align: center;">{{ fileSize }} MB</span>
    </div>
    <div style="padding-left: 25px;width: 35%;float: left;display: flex;">
      <button class="excelSucessIcon" *ngIf="fileuploadStatusFlag"><img
        src="../../../../assets/img/Excel_Upload_Sucess.svg"/></button>
      <button class="excelSucessIcon" *ngIf="!fileuploadStatusFlag"><img
        src="../../../../assets/img/Excel_Upload_Fail.svg"/></button>
      <div *ngIf="fileuploadStatusFlag" class="successMessage">Uploaded Successfully</div>
      <div *ngIf="!fileuploadStatusFlag" class="successMessage">Upload Falied.</div>
    </div>
    <div style="padding-left: 210px;">
      <button class="closeButton" (click)="closeUploaded()">close</button>
    </div>
  </div>
</div>
<div [hidden]="!pgLoad" style="padding-top: 40px;">
  <div class="adjust loader-container">
    <div class="loader2"></div>
  </div>
</div>
<div class="filesContainer" [hidden]="pgLoad">
  <div class="headerDiv">
    <div class="headerFile"> Uploaded Files</div>
    <div class="inputDiv">
      <!-- <input type="text" class="icon" value placeholder="Search by Error"> -->
    </div>
  </div>
  <div *ngIf="filesUploaded.length == 0" class="rowStack">
    No Records Found
  </div>
  <div class="rowStack" *ngFor="let record of filesUploaded; let i = index">
    <div>
      <div class="columnStack16">
        <span class="dateName" style="padding-bottom: 10px;">{{ record.date | date:'dd-MMM-yyyy h:mm:ss a' }}</span>
        <span class="dateName" style="padding-top: 5px;">{{ record.uploadedBy }}</span>
      </div>
      <div class="columnStack25">
        <span class="dateName">{{ record.filename }}.xslx &nbsp;</span>
        <span class="dateName" *ngIf="record.success"><button class="successImage"><img
          src="../../../../assets/img/Success.svg" style="width: 24px;height: 35px;"/></button><br/></span>
        <span class="dateName" *ngIf="!record.success"><button class="successImage"><img
          src="../../../../assets/img/Failure.svg" style="width: 24px;height: 35px;"/></button><br/></span>
      </div>
      <div class="columnStack13">
        <span class="totalrecHeader">Total rows</span>
        <span class="totalData">{{ record.total_rows }}</span>
      </div>
      <div class="columnStack13">
        <span class="totalrecHeader">Recorded</span>
        <span class="totalData">{{ record.recorded }}</span>
      </div>
      <div class="columnStack13">
        <span class="totalrecHeader">Defects</span>
        <span class="totalData" style="color: red;">{{ record.defects }}</span>
      </div>
      <div class="columnStack20">
        <span>{{ record.comments }}</span>
        <span>{{ record.comment1 }}</span>
        <span>{{ record.comment2 }}</span>
      </div>
    </div>
  </div>
  <div *ngIf="listLoader" class="loader-div">
    <div class="adjust">
      <div class="loader2 list-loader"></div>
    </div>
  </div>
</div>
